<template>
	<div
		id="originator-management"
		:class="[!isWeb ? 'mobile-originator-management' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="originator-management__body">
			<TableFilter :isWeb="isWeb" @searchFromInput="searchFromInput" />
			<OriginatorTable
				:isWeb="isWeb"
				:currentPage="page"
				@changePage="changePage"
				@refreshOriginators="refreshOriginators"
				@orderByHeader="orderByHeader"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import {
	GET_ALL_ORIGINATORS,
	GET_ORIGINATORS_STATUS,
} from '@/store/modules/originatorManagement/actions';
import TableFilter from '@/components/modules/Originator/OriginatorManagement/TableFilter/TableFilter.vue';
import OriginatorTable from '@/components/modules/Originator/OriginatorManagement/Table/Table.vue';

export default {
	name: 'OriginatorManagement',
	components: { TableFilter, OriginatorTable },
	data: () => ({
		windowWidth: window.innerWidth,
		page: 1,
		searchParams: null,
		headerSelected: null,
		orderSelected: null,
	}),
	created() {
		this.refreshOriginators();
		this.getOriginatorsStatus({ vm: this });
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		...mapActions('originatorManagement', {
			getOriginators: GET_ALL_ORIGINATORS,
			getOriginatorsStatus: GET_ORIGINATORS_STATUS,
		}),
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		changePage(params) {
			this.page = params.params;
			this.refreshOriginators();
		},
		searchFromInput(params) {
			this.searchParams = params;
			this.page = 1;
			this.refreshOriginators();
		},
		orderByHeader(param) {
			if (this?.headerSelected === param) {
				if (this.orderSelected === 'ASC') {
					this.orderSelected = 'DESC';
				} else {
					this.orderSelected = 'ASC';
				}
			} else {
				this.orderSelected = 'DESC';
			}
			this.headerSelected = param;
			this.refreshOriginators();
		},
		refreshOriginators() {
			let params = `?limit=20&page=${this.page}`;
			if (this.searchParams) params += `&search=${this.searchParams}`;
			if (this.headerSelected)
				params += `&orderColumn=${this.headerSelected}&orderDirection=${this.orderSelected}`;

			this.getOriginators({ vm: this, params: params });
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'OriginatorManagement.scss';
</style>
